import React from 'react';
import { cn } from '../../../lib/utils';

// Segmented: a labelled group of toggle buttons (the queue and log filters).
export function Segmented({ label, caption, children }) {
  return (
    <div role="group" aria-label={label} className="flex flex-wrap items-center gap-0.5 rounded-xl border border-white/10 bg-surface-1 p-1">
      {caption && <span className="pl-2 pr-2.5 text-xs text-ink-dim">{caption}</span>}
      {children}
    </div>
  );
}

export function SegButton({ on, onClick, children }) {
  return (
    <button
      type="button" aria-pressed={on} onClick={onClick}
      className={cn('flex min-h-10 items-center gap-2 rounded-lg px-3.5 text-[13px] font-bold transition-colors',
        on ? 'bg-ink text-surface' : 'text-ink-dim hover:text-ink')}
    >
      {children}
    </button>
  );
}
